export enum ActiveTablesSortProperty {
  LIMITS = 'Limits',
  OBSERVERS = 'Observers',
  BOTS = 'Bots',
  LIVE_PLAYERS = 'Live players',
}
